<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-row class="mc-card__list">
            <b-col
              v-if="
                hasAccess([
                  'maintenance:read',
                  'maintenance:create',
                  'maintenance:update',
                  'maintenance:delete',
                ])
              "
              sm="12"
              md="6"
            >
              <b-button
                variant="outline-light"
                class="d-block w-100 mc-card__list-item clearfix"
                @click="$router.push({ name: 'List Service Schedule' })"
              >
                <i class="mc-fa icon-outline_scheduler"></i>
                <McBadge
                  v-if="isNewSubmodule('m1a-maintenancescheduler')"
                  :text="$t('global.new')"
                  variant="danger"
                  size="medium"
                  type="pill"
                  class="text-uppercase float-end"
                />
                <div class="mc-card__list-item-content">
                  <h4>{{ $t('maintenance.frontPage.title.serviceSchedule') }}</h4>
                  <p>{{ $t('maintenance.frontPage.desc.schedule') }}</p>
                </div>
              </b-button>
            </b-col>

            <b-col
              v-if="
                hasAccess([
                  'maintenance-group:read',
                  'maintenance-group:update',
                  'maintenance-group:create',
                  'maintenance-group:delete',
                ])
              "
              sm="12"
              md="6"
            >
              <b-button
                variant="outline-light"
                class="d-block w-100 mc-card__list-item clearfix"
                @click="$router.push({ name: 'Service Group' })"
              >
                <i class="mc-fa icon-outline_cube"></i>
                <McBadge
                  v-if="isNewSubmodule('m1c-maintenancegroup')"
                  :text="$t('global.new')"
                  variant="danger"
                  size="medium"
                  type="pill"
                  class="text-uppercase float-end"
                />
                <div class="mc-card__list-item-content">
                  <h4>{{ $t('maintenance.frontPage.title.serviceGroup') }}</h4>
                  <p>{{ $t('maintenance.frontPage.desc.group') }}</p>
                </div>
              </b-button>
            </b-col>

            <b-col
              v-if="
                hasAccess([
                  'maintenance:read',
                  'maintenance:create',
                  'maintenance:update',
                  'maintenance:delete',
                ])
              "
              sm="12"
              md="6"
            >
              <b-button
                variant="outline-light"
                class="d-block w-100 mc-card__list-item clearfix"
                @click="$router.push({ name: 'List Service Alert' })"
              >
                <i class="mc-fa icon-outline_alert-triangle"></i>
                <McBadge
                  v-if="isNewSubmodule('m1b-maintenancereminder')"
                  :text="$t('global.new')"
                  variant="danger"
                  size="medium"
                  type="pill"
                  class="text-uppercase float-end"
                />
                <div class="mc-card__list-item-content">
                  <h4>{{ $t('maintenance.frontPage.title.serviceAlert') }}</h4>
                  <p>{{ $t('maintenance.frontPage.desc.alert') }}</p>
                </div>
              </b-button>
            </b-col>

            <b-col
              v-if="
                hasAccess([
                  'service_order:read',
                  'service_order:update',
                  'service_order:create',
                  'service_order:delete',
                ])
              "
              sm="12"
              md="6"
            >
              <b-button
                variant="outline-light"
                class="d-block w-100 mc-card__list-item clearfix"
                @click="$router.push({ name: 'Service Order List' })"
              >
                <i class="mc-fa icon-outline_truck-maintenance"></i>
                <div class="mc-card__list-item-content">
                  <h4>{{ $t('maintenance.frontPage.title.serviceOrder') }}</h4>
                  <p>{{ $t('maintenance.frontPage.desc.order') }}</p>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { todoComputed, todoMethods } from '@/state/helpers'
import McBadge from '@/components/McBadge'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Service',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    ...todoComputed,
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    /**
     * Total no. of records
     */

    title() {
      return this.$t('menuitems.service.text')
    },
  },

  methods: {
    ...todoMethods,
  },
}
</script>
